// extracted by mini-css-extract-plugin
export default {"whyUs":"styles_whyUs__y7iqv","title":"styles_title__PkgJR","rtl":"styles_rtl__-aDIO","list":"styles_list__05CYL","listItem":"styles_listItem__yB2gk","icon":"styles_icon__qEGGQ"};